/* Upshift R-PRO: place the post-buy Rich Text block above three accordion
   blocks beneath the gallery on desktop. Move the actual elements, never copies,
   and restore their original placement on mobile and when resizing. */
(() => {
  if (window.__upshiftRproAccordionLayoutLoaded) return;
  window.__upshiftRproAccordionLayoutLoaded = true;

  const mq = window.matchMedia('(min-width: 768px)');

  const applyLayout = () => {
    document.querySelectorAll('[data-upshift-rpro-accordion-dock]').forEach((dock) => {
      const root = dock.closest('product-form');
      if (!root) return;

      const items = Array.from(root.querySelectorAll(
        '[data-upshift-rpro-richtext], [data-upshift-rpro-accordion]'
      )).sort((a, b) => Number(a.dataset.upshiftRproOrder) - Number(b.dataset.upshiftRproOrder));

      items.forEach((item) => {
        if (!item.__upshiftAccordionPlaceholder || !item.__upshiftAccordionPlaceholder.isConnected) {
          if (!item.parentNode) return;
          const placeholder = document.createComment('Upshift R-PRO original block position');
          item.parentNode.insertBefore(placeholder, item);
          item.__upshiftAccordionPlaceholder = placeholder;
        }

        if (mq.matches) {
          // appendChild reuses the original element and preserves its event handlers.
          dock.appendChild(item);
        } else {
          const placeholder = item.__upshiftAccordionPlaceholder;
          if (placeholder?.parentNode && item.previousSibling !== placeholder) {
            placeholder.parentNode.insertBefore(item, placeholder.nextSibling);
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLayout, { once: true });
  } else {
    applyLayout();
  }

  if (mq.addEventListener) mq.addEventListener('change', applyLayout);
  else mq.addListener(applyLayout);

  document.addEventListener('shopify:section:load', applyLayout);
})();
